import { APPLICATIONS_ID } from "@next-platform/client-common-core/infra/constants/domains";

type NextDayApplicationId = APPLICATIONS_ID.SpicyChat | APPLICATIONS_ID.PixelChat | APPLICATIONS_ID.SecretMate;

export const SUPPORT_URL_BY_APPLICATION_ID: Record<NextDayApplicationId, string> = {
  [APPLICATIONS_ID.SpicyChat]: "https://support.spicychat.ai",
  [APPLICATIONS_ID.PixelChat]: "https://support.pixelchat.ai",
  [APPLICATIONS_ID.SecretMate]: "https://support.secretmate.ai",
};

export const ORG_ADDRESSES = [
  `NextDay AI Incorporated - 4388 Saint-Denis, Suite 200, Montreal, Quebec, H2J2L1, Canada`,
  `NextDay AI USA Inc - 2915 Ogletown Road, Suite 4642, Delaware, 19713, USA`,
  `NextDay AI EU Ltd - 2 Poreias, Limassol, 3011, Cyprus`,
];

/* eslint-disable @typescript-eslint/naming-convention -- Legacy asset constants are imported by existing UI modules using these names. */
export const AppStoreDark = "/Assets/appstore_AppStore_Light.svg";
export const AppStoreLight = "/Assets/appstore_AppStore_Dark.svg";
export const AndroidDark = "/Assets/appstore_GooglePlay_Light.svg";
export const AndroidLight = "/Assets/appstore_GooglePlay_Dark.svg";
export const GetItOnPlayStoreDark = "/Assets/playStore-dark.svg";
export const GetItOnPlayStoreLight = "/Assets/playStore-light.svg";
/* eslint-enable @typescript-eslint/naming-convention -- Restore standard constant naming rules. */

export const SPICYCHAT_DISCORD = "https://discord.gg/spicychatai";
export const SPICYCHAT_TWITTER = "https://twitter.com/SpicyChatAI";
export const SPICYCHAT_REDDIT = "https://www.reddit.com/r/SpicyChatAI/";

export const SPICYCHAT_GUIDELINES_CTA = "https://docs.spicychat.ai/community-guidelines";

export const GLEAM_LINK =
  '<a class="e-widget no-button" href="https://gleam.io/5MfyT/easter-giveaway" rel="nofollow">Easter Giveaway</a><script type="text/javascript" src="https://widget.gleamjs.io/e.js" async="true"></script>';
